import { useMutation, useQueryClient } from "@tanstack/react-query";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";
import {
  updateQuoteRequest,
  UpdateQuoteRequestDto,
} from "#modules/quoteRequests/infra/updateQuoteRequest.api";

export const useUpdateQuoteRequestInfos = (
  options: {
    shouldShowSuccessToast?: boolean;
  } = { shouldShowSuccessToast: true },
) => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, ...rest } = useMutation({
    mutationFn: ({
      id,
      orderType,
      reference,
      dueDate,
      clientId,
      contactId,
      billingAddressId,
      salesMarginRatio,
      discountRatio,
      expirationDate,
      comment,
      clientNote,
      clientReference,
      quoteRequestLines,
    }: UpdateQuoteRequestDto) =>
      updateQuoteRequest({
        id,
        quoteRequest: {
          orderType,
          reference,
          dueDate,
          clientId,
          contactId,
          billingAddressId,
          salesMarginRatio,
          discountRatio,
          expirationDate,
          comment,
          clientNote,
          clientReference,
          quoteRequestLines: quoteRequestLines?.map((line) => ({
            id: line.id,
            shippingDelay: line.shippingDelay,
          })),
        },
      }),
    onSuccess: (data) => {
      void queryClient.invalidateQueries(quoteRequestQuery(data.id));
      if (options.shouldShowSuccessToast) {
        showSuccessToast({ title: "Informations sur la demande mises à jour" });
      }
    },

    onError: (error) => {
      logger.error(error);
      showErrorToast({ title: "Une erreur est survenue" });
    },
  });

  return {
    updateQuoteRequestInfos: mutate,
    updateQuoteRequestInfosAsync: mutateAsync,
    ...rest,
  };
};
